import { render } from "./ServerSidebar.vue?vue&type=template&id=76c66e0c"
import script from "./ServerSidebar.vue?vue&type=script&lang=js"
export * from "./ServerSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__